import React, { useReducer } from "react";
import ContractorsContext from "./ContractorsContext";
import ContractorsReducer from "./ContractorsReducer";
import { getContractorsService } from "../../services/contractors";

const ContractorsState = ({ children }) => {

    const initialState = {
        contractors: [],
        wasFetched: false
    }

    const [state, dispatch] = useReducer(ContractorsReducer, initialState);

    const getContractors = async () => {
        try {
            if (state.wasFetched === false) {
                const contractors = await getContractorsService();
                if (contractors.ok) {
                    dispatch({
                        type: 'GET_ALL_CONTRACTORS',
                        payload: contractors.data.response.contractors
                    });
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <ContractorsContext.Provider
            value={{
                contractorsState: state,
                getContractors
            }}>
            {children}
        </ContractorsContext.Provider>
    )
}

export default ContractorsState